/* istanbul ignore file */
import { componentService } from 'js/services/component.service';
import { compose } from 'ramda';
import { withComponent } from 'js/components/hocs/withComponent';
import { withDynamicReducer } from './store';
import { FreeSpinsBalanceBare } from './FreeSpinsSwiss';
import { FREE_SPINS_SWISS } from './constants';

export const FreeSpinsSwiss = compose(
    withComponent({
        isForLoggedIn: true,
        tkPrefix: 'playtech.mobile.system.freespin.'
    }),
    withDynamicReducer()
)(FreeSpinsBalanceBare);

componentService.registerPageComponents({ [FREE_SPINS_SWISS]: FreeSpinsSwiss });
